import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { omit } from "ramda";
import { loadStripe } from "@stripe/stripe-js";
import { Honeybadger } from "@honeybadger-io/react";

export const RedirectReceiptPageContext = React.createContext();

const RedirectPageProvider = ({ bootstrap, sweepstakes, children }) => {
  const { promo: promoCodeName, donationId, paymentIntentClientSecret, paymentMethod } = bootstrap;
  const stripePromise = useMemo(() =>
    loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY, {
      stripeAccount: sweepstakes.nonprofit.paymentAccountId,
      apiVersion: import.meta.env.VITE_STRIPE_API_VERSION,
    })
  , []);
  const [paymentIntent, setPaymentIntent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPaymentIntent = async () => {
      try {
        const stripe = await stripePromise;
        const { paymentIntent } = await stripe.retrievePaymentIntent(paymentIntentClientSecret);
        if (!paymentIntent) {
          Honeybadger.notify("Failed to fetch payment intent", {
            context: {
              bootstrap: omit(['paymentIntentClientSecret'], bootstrap),
              sweepstakes,
            },
          });
          navigate("/");
          return;
        }

        setPaymentIntent(paymentIntent);
      } catch (error) {
        Honeybadger.notify(error, {
          context: {
            bootstrap: omit(['paymentIntentClientSecret'], bootstrap),
            sweepstakes,
          },
        });
        navigate("/");
      }
    };

    fetchPaymentIntent();
  }, []);

  return (
    <RedirectReceiptPageContext.Provider value={{ paymentIntent, paymentMethod, sweepstakes, donationId, promoCodeName }}>
      {children}
    </RedirectReceiptPageContext.Provider>
  );
}

export default RedirectPageProvider;
